import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';


import { EnvironmentService, EnvironmentServiceConfig } from './environment';
import { AuthenticationService } from '../_services/authentication/authentication.service';
import { HttpService } from './http';
import { MessagingService } from './messaging';
import { AuthGuard } from './security';
import { NavigationService } from './navigation';
import { SubMenuService } from './menu';

import { SystemConfig, Standard, ClasOhlsson } from './environment/system-config';

import * as services from '../_services';

@NgModule({
	imports: [
		CommonModule
	],
	declarations: [],
	exports: []
})
export class CoreModule {
	static forRoot(environment: string): ModuleWithProviders {
		return {
			ngModule: CoreModule,
			providers: [
				CookieService,
				AuthenticationService, HttpService, MessagingService, AuthGuard, NavigationService, SubMenuService,
				{ provide: EnvironmentServiceConfig, useValue: { environment: environment } },
				{ provide: SystemConfig, useClass: ClasOhlsson },
				EnvironmentService,

				services.PremisesService,
				services.CommonService,
				services.StoreService,
				services.ProjectService,
				services.AddressTypeService,
				services.AreaPlannerService,
				services.ContactService,


				services.FileService,

				services.IndustryService,
				services.ModelStateValidationService,
				services.SupplierService,
				services.SupplierAddressService,
				services.SupportDataService,
				services.SystemTableService,

				services.ContractService,
				services.DemarcationListService,
				services.ContractTemplateService,

				services.ApiService
			]
		};
	}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/core/core.module.ts